import { useEffect, useState } from "react";

import { table as tableApi } from "../../../../../resources/tables";

export const useTableInfo = (tableName: string) => {
  const [structureLoading, setStructureLoading] = useState<boolean>(true);
  const { data: tableInfo, refetch } = tableApi.use({ input: tableName, waitInput: true, immediate: false });

  useEffect(() => {
    refetch().then(() => setStructureLoading(false));
  }, [refetch]);

  return { tableStructure: tableInfo, loading: structureLoading };
};
